<template>
  <div>
    <page-section :title="$t('Integrations_Overview_Information')">
      <form-section>
        {{ $t('Integrations_Optimove_Text_Information') }}
      </form-section>
    </page-section>

    <page-section :title="$t('Integrations_Optimove_Channels')">
      <rest-list
        :payload="channelsStatusEndpoint"
        ref="channels-status-list"
        :filterable="false"
      >
        <rest-list-column-enum
          prop="channel"
          :title="$t('Integrations_Optimove_Channel')"
          :enum="channels"
        />

        <rest-list-column-boolean
          prop="enabled"
          :title="$t('Integrations_Optimove_Channel_Enabled')"
          :width="200"
        />

        <rest-list-column
          prop="status"
          :title="$t('Integrations_Optimove_Channel_Status')"
          :width="200"
        />

        <rest-list-column-actions>
          <template slot-scope="scope">
            <rest-list-action
              v-if="!scope.row.enabled"
              icon="el-icon-circle-plus-outline"
              :title="$t('Integrations_Optimove_Channel_Enable')"
              :click="() => enableChannel(scope.row.channel)"
            />

            <rest-list-action
              v-if="scope.row.enabled"
              icon="el-icon-circle-close"
              :title="$t('Integrations_Optimove_Channel_Disable')"
              :click="() => disableChannel(scope.row.channel)"
            />
          </template>
        </rest-list-column-actions>
      </rest-list>
    </page-section>
  </div>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import { OptimoveChannelLabel } from '@/modules/integrations/types/optimove/OptimoveChannelEnums'
import PageSection from '@/common/components/page/PageSection'
import FormSection from '@/common/components/form/FormSection'
import RestApi from '@/core/services/RestApi'
import RestList from '@/common/components/rest/RestList'
import RestListColumnBoolean from '@/common/components/rest/RestListColumnBoolean'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListAction from '@/common/components/rest/RestListAction'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { $hasFeature } from '@/core/utils/VueAcl'

export default {
  name: 'OptimoveOverview',

  components: {
    RestListColumn,
    RestListColumnEnum,
    RestListAction,
    RestListColumnActions,
    RestListColumnBoolean,
    RestList,
    FormSection,
    PageSection
  },

  props: {
    model: {
      required: false
    }
  },

  computed: {
    channels() {
      let availableChannels = Object.assign({}, OptimoveChannelLabel)

      if (!$hasFeature('optimoveLists')) {
        delete availableChannels['509']
      }

      return availableChannels
    },
    channelsStatusEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `integrations/optimove/${this.$route.query.id}/channels-status`
      })
    },

    channelsStatusList() {
      return this.$refs['channels-status-list']
    }
  },

  methods: {
    enableChannel(channelId) {
      this.channelsStatusList.loading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `integrations/optimove/${this.$route.query.id}/enable-channel`,
          data: { channel_id: channelId }
        })
      )
        .then(() => {
          this.channelsStatusList.refresh()
          this.$store.dispatch('reloadProjectConfig')
          this.channelsStatusList.loading = false
          this.$message({
            message: this.$t(
              'Integrations_Optimove_Channel_SuccessfullyEnabled'
            ),
            type: 'success'
          })
        })
        .catch(error => {
          this.channelsStatusList.loading = false
          this.$message({
            message: error.response.data.message,
            type: 'error'
          })
        })
    },

    disableChannel(channelId) {
      this.channelsStatusList.loading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `integrations/optimove/${this.$route.query.id}/disable-channel`,
          data: { channel_id: channelId }
        })
      )
        .then(() => {
          this.channelsStatusList.refresh()
          this.$store.dispatch('reloadProjectConfig')
          this.channelsStatusList.loading = false
          this.$message({
            message: this.$t(
              'Integrations_Optimove_Channel_SuccessfullyDisabled'
            ),
            type: 'success'
          })
        })
        .catch(error => {
          this.channelsStatusList.loading = false
          this.$message({
            message: error.response.data.message,
            type: 'error'
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/optimove/OptimoveOverview.vue